<template>
  <div v-if="createdBy && dateTime" class="col-lg-4 col-12">
    <div class="alert alert-primary alert-dismissible alert-label-icon label-arrow fade show" role="alert">
      <i class="ri-user-smile-line label-icon"></i>
      Created By: <strong>{{ createdBy }}</strong> <br>
      Date Created: <strong>{{ formattedDateTime }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreatedInfo",
  props: {
    createdBy: {
      type: String,
      required: true
    },
    dateTime: {
      type: [String, Date],
      required: true
    }
  },
  computed: {
    formattedDateTime() {
      const date = new Date(this.dateTime);

      const dateOptions = { year: "numeric", month: "short", day: "numeric" };
      const timeOptions = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false };

      const formatDate = date.toLocaleDateString("en-US", dateOptions);
      const formatTime = date.toLocaleTimeString("en-US", timeOptions);

      return `${formatDate} ${formatTime}`;
    }
  }
};
</script>